<div class="p-2 align-self-start" *ngFor="let item of this.relacionades" > <a (click)="this.veurePropostaRelacionada(item)"> {{item.NUMDENUNCIA}} </a> </div> 